import { render, staticRenderFns } from "./ProcurementPowerbiReport.vue?vue&type=template&id=425a74fd&scoped=true&"
import script from "./ProcurementPowerbiReport.vue?vue&type=script&lang=js&"
export * from "./ProcurementPowerbiReport.vue?vue&type=script&lang=js&"
import style0 from "./ProcurementPowerbiReport.vue?vue&type=style&index=0&id=425a74fd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425a74fd",
  null
  
)

export default component.exports